<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Panel from "../Panel.svelte";
  import type { Month } from "../lib/date-time";
  import { DatePickerTranslations } from "../DatePicker.i18n";

  export let year: number;
  export let month: number;
  export let language: string;

  const dispatcher = createEventDispatcher();

  $: list = new Array<Month>(12).fill(0).map((_, i) => i + 1);

  $: T = DatePickerTranslations(language);
</script>

<Panel on:prev={(_) => (year -= 1)} on:next={(_) => (year += 1)} on:back>
  <div slot="header">{year}</div>
  <div class="lrs-grid">
    {#each list as x}
      <div class="lrs-grid-item" class:active={x == month} on:click={(_) => dispatcher("select", { year: year, month: x })}>{T.get("getMonthName", x)}</div>
    {/each}
  </div>
</Panel>

<style lang="scss">
  .lrs-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 2px;
    padding: 0.5em;

    .lrs-grid-item {
      padding: 0.5em 1em;
      border-radius: 9999px;
      text-align: center;
      cursor: pointer;

      &.active {
        box-shadow: 0 0 0 2px #000;
      }

      &:hover {
        background-color: rgba(#000, 0.1);
      }
    }
  }
</style>
